/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SignedConfigResponseSignature { 
    /**
     * hashing algorithm used to get digest of config section
     */
    alg?: string;
    /**
     * encrypted hash value of config section
     */
    value?: string;
}

